export default __webpack_public_path__ + "static/media/Valentine2.3ada7cbb.png";